/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {UsersComponent} from './users/users.component';
import {UserDetailsComponent} from './user/user-details/user-details.component';
import {UserEditComponent} from "./user/user-edit/user-edit.component";
import { AuthLogsComponent } from './auth-log/auth-logs/auth-logs.component';
import { OwnedAuthLogsComponent } from './auth-log/owned-auth-logs/owned-auth-logs.component';

const ROUTES = [
  /*
    {
        path: 'login',
        component: LoginComponent
    },
   */
  {
    path: 'users',
    component: UsersComponent,
    // data: {
    //     authorities: ['ROLE_UTILIZATORI']
    // }

  },
  {
    path: 'authLogs',
    component: AuthLogsComponent,
    data: {
      authorities: [['ROLE_UTILIZATORI'], ['ROLE_ADMIN']]
    }
  },
  {
    path: 'owned-auth-logs',
    component: OwnedAuthLogsComponent
  },
  {
    path: 'user/:uuid',
    component: UserEditComponent,
    // data: {
    //     authorities: ['ROLE_UTILIZATORI']
    // }
  },
  {
    path: 'user',
    component: UserEditComponent,
    // data: {
    //     authorities: ['ROLE_UTILIZATORI']
    // }
  },
  {
    path: 'profile/:uuid',
    component: UserDetailsComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(ROUTES)
  ],
  exports: [
    RouterModule
  ]
})
export class AuthRoutingModule {
}
